module.exports = __webpack_public_path__ + "img/target.b28c366c.png";